<template>
    <div>
        <div class="content-box first">
            <RsStep class="full m-b-8" :active="1" :steps="['发起分账', '确认并签署合同', '完成分账']"></RsStep>
            <p class="sr-tips" style="margin-bottom: 30px">
                1. 确认每首歌曲的分成的比例
                <br />
                2. 秀动发行结算至你提供的手机号的注册用户
                <br />
                3. 未注册的用户，则系统会暂留该比分成收入，供你分配
            </p>
            <iframe
                :src="info.contractFileFullPath"
                v-loading="pageLoading"
                style="height: 527px; background: #f5f7fa; width: 100%"
                frameborder="0"
                scrolling="no"
            ></iframe>
            <div style="text-align: center; margin-top: 30px">
                <el-button type="primary" @click="dialogVisible = true">确认签署</el-button>
            </div>
        </div>
        <el-dialog title="签署合同" append-to-body :visible.sync="dialogVisible" width="450px" center>
            <div class="contract-body">
                <el-alert
                    v-if="smsTime !== 0"
                    :title="`您尾号为${phone}的手机将会收到认证服务商“电子牵”的认证短信验证码，请填写验证码以进行电子身份认证`"
                    :closable="false"
                    type="warning"
                    show-icon
                ></el-alert>
                <div class="item">
                    <label>手机号：</label>
                    <div class="cont">
                        <el-input placeholder="手机号码" disabled v-model="telephone"></el-input>
                    </div>
                </div>
                <div class="item">
                    <label>验证码：</label>
                    <div class="cont">
                        <el-input placeholder="验证码" v-model="smsCode">
                            <el-button @click="sendSms" slot="append">
                                {{ smsTime === 0 ? '获取验证码' : `( ${smsTime}s )` }}
                            </el-button>
                        </el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" v-loading="signContractLoading" @click="signContract()">确认签署</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {getSongsRuleContract, signSongsRuleContract} from '@/api/distribute';
import {getEnterpriseContractSms} from '@/api/user';
export default {
    data() {
        return {
            ruleId: '',
            info: {},
            pageLoading: false,
            dialogVisible: false,
            serialNumber: '',
            smsTime: 0,
            smsCode: '',
            telephone: '',
            signContractLoading: false,
        };
    },
    computed: {
        phone() {
            const {telephone} = this;
            return telephone ? telephone.slice(-4) : '';
        },
    },
    mounted() {
        const {
            query: {ruleId},
        } = this.$route;
        this.$dzqToFdd();
        if (ruleId) {
            this.ruleId = ruleId;
            this.getContract(ruleId);
            const {telephone} = this.$store.state.userInfo || {};
            if (telephone) this.telephone = telephone;
        }
    },
    methods: {
        async getContract(ruleId) {
            this.pageLoading = true;
            const respnose = await getSongsRuleContract(ruleId);
            const {state, msg, result} = respnose.data;
            this.pageLoading = false;
            if (!state) return this.$message.error(msg || '获取数据失败,请重试');
            this.info = result;
        },
        // 获取签署验证码
        async sendSms() {
            if (this.smsTime > 0) return;
            const response = await getEnterpriseContractSms(this.info.contractCode);
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            this.serialNumber = result.serialNumber;
            this.smsTime = 60;
            const smsInterval = setInterval(() => {
                this.smsTime -= 1;
                if (this.smsTime <= 0) clearInterval(smsInterval);
            }, 1000);
        },
        // 签署合同
        async signContract() {
            if (!this.smsCode) return this.$message.error('请填写短信验证码');
            if (!this.serialNumber) return this.$message.error('您还未获取验证码');
            if (this.signContractLoading) return;
            this.signContractLoading = true;
            const {smsCode, serialNumber} = this;
            const {contractCode} = this.info;
            const response = await signSongsRuleContract(contractCode, serialNumber, smsCode, this.ruleId);
            const {state, msg} = response.data;
            this.signContractLoading = false;
            if (!state) return this.$message.error(msg || '抱歉，签署失败，请确认输入的短信验证码是否正确');
            this.dialogVisible = false;
            this.$router.push({path: `/manage/distribute/detail/3?ruleId=${this.ruleId}`});
        },
    },
};
</script>
<style lang="scss">
.contract-body {
    .item {
        display: flex;
        margin-top: 10px;

        label {
            width: 60px;
            line-height: 40px;
        }

        .cont {
            flex: 1;
            display: flex;
        }
    }
}
</style>
